var _excluded = ["children", "background", "padding"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { Stack } from "./..";
var DialogBackgroundColorMap = {
  white: 'white',
  grey: 'grey.100'
};
export var DialogContent = function DialogContent(_ref) {
  var children = _ref.children,
      _ref$background = _ref.background,
      background = _ref$background === void 0 ? 'white' : _ref$background,
      padding = _ref.padding,
      others = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Stack, _extends({
    space: "small",
    _sx: {
      padding: padding === 'none' ? 0 : 4,
      backgroundColor: DialogBackgroundColorMap[background]
    }
  }, others), children);
};
DialogContent.displayName = 'DialogContent';